import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { editTopic, getTopicsByTenantId, saveTopic } from "./thunks";

const initialState = {
  topicsByTenants: {},
  loading: true,
};

const topicsSlice = createSlice({
  name: "topics",
  initialState,
  reducers: {
    setKeyValue: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTopicsByTenantId.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTopicsByTenantId.fulfilled, (state, action) => {
        const { tenant_id } = action.meta.arg;
        const { data } = action.payload;

        state.topicsByTenants[tenant_id] = data;
        state.loading = false;
      })
      .addCase(getTopicsByTenantId.rejected, (state) => {
        state.loading = false;
      })
      .addCase(saveTopic.fulfilled, (state, action) => {
        const { data, message: successMessage } = action.payload;
        state.topicsByTenants[data?.tenant_id].push(data);
        message.success(successMessage || "Topic added successfully!");
      })
      .addCase(editTopic.fulfilled, (state, action) => {
        const { data, message: successMessage } = action.payload;

        const topics = state.topicsByTenants[data?.tenant_id];
        const index = topics.findIndex((b) => b.id === data.id);
        if (index !== -1) {
          topics[index] = data;
          message.success(successMessage || "Topic updated successfully!");
        }
      });
  },
});

export const { setKeyValue } = topicsSlice.actions;

export default topicsSlice.reducer;
